/*
 * fn: filterCombos
 *
 * Keeps the combos that fit the filters active on a route: color identity, bracket, and "without card"
 *
 */
import { type ComboPreviewType } from '@/defs/combo'
import { isFilterAdvancedCardType } from '@/defs/filters'
import { type RouteType } from '@/defs/route'
import { getCardFrontId, isInColorId } from '@/utils/cardUtil'

import { getComboBracketStatus } from './getComboBracketStatus'

type Props = {
  combos: ComboPreviewType[]
  route?: Partial<RouteType>
}

export const filterCombos = ({ combos, route }: Props) => {
  const { advancedFilters, bracket, colorId } = route || {}
  const excludedCardIds = new Set(
    advancedFilters?.flatMap((filter) =>
      isFilterAdvancedCardType(filter) && filter.slug === 'withoutCard' ? [getCardFrontId(filter.card)] : [],
    ),
  )

  if (!colorId && !bracket && excludedCardIds.size < 1) return combos

  return combos.filter(
    (combo) =>
      (!colorId || isInColorId(combo.colorId, colorId)) &&
      (!bracket || getComboBracketStatus({ bracket, combo }).status !== 'invalid') &&
      !combo.cards.some((card) => excludedCardIds.has(getCardFrontId(card.cardId))),
  )
}
